/**
 * @generated SignedSource<<480f3836f51538a441efaa06339750a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditCheckinInput = {
  checkinId: string;
  clientMutationId?: string | null;
  data: EditCheckinDataInput;
};
export type EditCheckinDataInput = {
  answers?: ReadonlyArray<EditCheckinAnswerInput | null> | null;
  public?: boolean | null;
  sentimentAnswer?: string | null;
  sentimentScore?: number | null;
};
export type EditCheckinAnswerInput = {
  body?: string | null;
  id?: string | null;
  questionId: string;
};
export type editCheckinMutation$variables = {
  input: EditCheckinInput;
};
export type editCheckinMutationVariables = editCheckinMutation$variables;
export type editCheckinMutation$data = {
  readonly editCheckin: {
    readonly checkin: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type editCheckinMutationResponse = editCheckinMutation$data;
export type editCheckinMutation = {
  variables: editCheckinMutationVariables;
  response: editCheckinMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditCheckinPayload",
    "kind": "LinkedField",
    "name": "editCheckin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Checkin",
        "kind": "LinkedField",
        "name": "checkin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editCheckinMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editCheckinMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f5b1dbc842237537229036fefb83713",
    "id": null,
    "metadata": {},
    "name": "editCheckinMutation",
    "operationKind": "mutation",
    "text": "mutation editCheckinMutation(\n  $input: EditCheckinInput!\n) {\n  editCheckin(input: $input) {\n    checkin {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "a1c878265d17dc58fb5f031267ca4d97";

export default node;
